import 'css-chunksrc/client/pages/taskPage/details/nameForm/styles.scss';export default {
  "input": "_input_1l6yc_1",
  "invalid": "_invalid_1l6yc_16"
};